module.exports = __webpack_public_path__ + "img/selected_cabinet_off.c96e4d46.svg";